import { defineComponent as _defineComponent } from 'vue'
import { PositionedInventory } from '@/models/Inventory'
import { computed, nextTick, ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { cloneDeep } from 'lodash'
import { NormalizedInventory } from '@/store/modules/assets'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import JobInventoryEditField from '@/components/tickets/JobInventoryEditField.vue'
import NewLocationPicker from '@/components/locations/NewLocationPicker.vue'
import { useBusinessUnitPermissions } from '@/components/tickets/common/useBusinessUnitPermissions'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobInventoryGroupEdit',
  props: {
    locationId: { default: null },
    inventories: null,
    activityId: { default: null },
    isPickupRequired: { type: Boolean },
    isDisabled: { type: Boolean },
    errorMessagesProps: { default: () => [] }
  },
  emits: [
  'add-inventory',
  'remove-inventory',
  'update-inventory',
  'add-group',
  'remove-group',
  'update-location',
],
  setup(__props: any, { emit }) {

const props = __props as { locationId: number | null, inventories: (PositionedInventory & { InvKey: string })[], activityId: number | null, isPickupRequired: boolean, isDisabled: boolean, errorMessagesProps: string[] }



const inventoryEditField = ref()
const errorMessages = ref<string[]>([])
const store = useStore()
const { canShowAllLocationsInLocationPicker, canCreateLocationOnTheFly } =
  useBusinessUnitPermissions()
const suggestedInventoriesByResourceTypeActivity = computed<
  (resourceTypeActivityId?: number | null) => NormalizedInventory[]
>(() => store.getters['assets/getInventoriesByResourceTypeActivity'])
const availableInventoryOptions = computed(() => {
  const allSuggestedInventories = cloneDeep(
    suggestedInventoriesByResourceTypeActivity.value(props.activityId)
  )

  for (const invGroup of allSuggestedInventories) {
    for (let i = 0; i < invGroup.assetConditions.length; i++) {
      invGroup.assetConditions[i] = {
        ...invGroup.assetConditions[i],
        disabled: false,
      }
    }
  }

  for (const inv of props.inventories) {
    const inventoryTypeIndex = allSuggestedInventories.findIndex(
      (invType) => invType.id === inv.inventoryTypeId
    )
    if (inventoryTypeIndex === -1) continue
    const inventorySubTypeIndex = allSuggestedInventories[
      inventoryTypeIndex
    ].assetConditions.findIndex(
      (invSubType) => invSubType.id === inv.inventorySubTypeId
    )
    if (inventorySubTypeIndex === -1) continue
    allSuggestedInventories[inventoryTypeIndex].assetConditions[
      inventorySubTypeIndex
    ].disabled = true
  }
  return allSuggestedInventories
})


function addInventory() {
  if (props.inventories.some((i) => i.inventorySubTypeId === null)) {
    focusEmptyInventoryAutoComplete()
  } else {
    emit('add-inventory')
    nextTick(() => {
      focusEmptyInventoryAutoComplete()
    })
  }
}

function focusEmptyInventoryAutoComplete() {
  const inventoryIndex = props.inventories.findIndex(
    (i) => i.inventorySubTypeId === null
  )
  inventoryEditField.value[inventoryIndex].focusInventoryType()
}

function updatePickupLocation(id?: number | number[]) {
  // In this scenario, we only expect id to be the type number | undefined only (not number[])
  errorMessages.value = []
  emit('update-location', id)
}

watch(
  () => props.errorMessagesProps,
  (newVal) => {
    errorMessages.value = newVal
  }
)

return { __sfc: true,props, inventoryEditField, errorMessages, store, canShowAllLocationsInLocationPicker, canCreateLocationOnTheFly, suggestedInventoriesByResourceTypeActivity, availableInventoryOptions, emit, addInventory, focusEmptyInventoryAutoComplete, updatePickupLocation, VsButton, VsText, JobInventoryEditField, NewLocationPicker }
}

})